import React from "react";
var __jsx = React.createElement;
import PencilBanner from './PencilBanner';
var PencilBannerAdapter = function PencilBannerAdapter(_ref) {
  var entry = _ref.entry,
    data = _ref.data;
  return __jsx(PencilBanner, {
    bannerData: entry,
    className: data === null || data === void 0 ? void 0 : data.className
  });
};
export default PencilBannerAdapter;